<template>

    <dialog-fullscreen :visibility.sync='visibility' :indicator='indicator'>
        <template v-slot:title>Редактирование фида ЦИАН</template>
        <template v-slot:action>
            <v-btn
                text
                color='green darken-2'
                @click="saveCian"
            >
                Обновить
            </v-btn>
        </template>
        <template v-slot:content>

            <v-card flat>
                <v-tabs
                    v-model='activeTab'
                    :slider-color='$store.getters.uiAccent'
                    :color='$store.getters.uiAccent'
                    grow
                    show-arrows
                    input='boundTabEvent'
                    :value='activeTab'
                >
                    <v-tab key='0' ripple>Общая информация об объявлении</v-tab>
                    <v-tab key='1' ripple>Информация о помещении</v-tab>
                </v-tabs>
            </v-card>

            <v-tabs-items v-model='activeTab' v-if="visibility">

                <v-tab-item key="0">

                    <v-form style='min-width: 320px; width: 615px;'>
                        <br>

                        <v-select
                            v-model="feed.cian_feed_format"
                            :items="[{value: 'basic', text: 'Основной фид'}, {value: 'additional', text: 'Дополнительный фид'}]"
                            label="Фид"
                            clearable
                        ></v-select>
                        <br>
                        <v-textarea
                            v-model="feed.cian.description"
                            label="Текст объявления"
                            :rules="[rules.required]"
                            @keydown="changeDinamicKey"
                        ></v-textarea>
                        <div v-if="mKeys">
                              <div class='key-list-item'
                                    v-for='(keyItem, index) in keyItems'
                                    :key='index'
                                    @click="insertKeyInText"
                                    :title=keyItem.text
                                   >
                                           {{ keyItem.value }}
                              </div>
                        </div>


                        <v-text-field
                            v-model="feed.cian.address"
                            label="Адрес объявления"
                            clearable
                            :rules="[rules.required]"
                        ></v-text-field>

                        <v-text-field
                            v-model="feed.cian.cadastral_number"
                            label="Кадастровый номер"
                            clearable
                        ></v-text-field>

                        <v-text-field
                            v-model.number="feed.cian.auction"
                            type="number"
                            label="Ставка на объявление в аукционе"
                            clearable
                        ></v-text-field>

                        <v-select
                            v-model="feed.cian.publish_terms"
                            :items="cian.publishTerms"
                            label="Условия размещения объявления"
                            clearable
                        ></v-select>

                        <v-text-field
                            v-model="feed.cian.title"
                            label="Заголовок объявления"
                            clearable
                            v-if="isPremium() || isTop()"
                        ></v-text-field>

                        <v-text-field
                            v-model="feed.cian.layout_photo"
                            label="Изображение планировки"
                        ></v-text-field>

                        <v-text-field
                            v-model="feed.cian.floor_plan_photo"
                            label="Изображение поэтажного плана"
                        ></v-text-field>

                        <v-text-field
                            v-model="feed.cian.videos"
                            label="Ссылка на видео"
                        ></v-text-field>

                        <v-textarea
                            v-model="feed.cian.photos"
                            label="Фотография объекта *"
                        >
                            <v-tooltip
                                :open-on-hover="true"
                                top
                                slot="append-outer"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <label style="color: red; font-weight: bold" v-bind="attrs" v-on="on"><span><v-icon>info</v-icon></span></label>
                                </template>
                                <div>
                                    Ссылки на фотографии<br>
                                    Каждая ссылка на отдельной строчке <br>
                                </div>
                            </v-tooltip>
                        </v-textarea>

                        <p>
                            Телефоны
                            <v-btn depressed x-small @click="addPhone">
                                <v-icon small>mdi-plus</v-icon>
                            </v-btn>
                        </p>
                        <v-container
                            v-for="(p, i) in feed.cian.phones"
                            :key="'phone_' + i"
                        >
                            <v-text-field
                                v-model="p.country_code"
                                label="Код страны"
                            >
                                <template slot="append-outer">
                                    <v-icon @click="removePhone(i)">mdi-minus</v-icon>
                                </template>
                            </v-text-field>
                            <v-text-field
                                v-model="p.number"
                                label="Номер"
                            ></v-text-field>
                        </v-container>

                    </v-form>

                </v-tab-item>
                <v-tab-item key="1">

                    <v-form style='min-width: 320px; width: 615px;'>

                        <v-autocomplete
                            :items="cian.categories"
                            :rules="[rules.required]"
                            v-model="feed.cian.category"
                            label="Категория объявления"
                            @change="changeCategory"
                            clearable
                        ></v-autocomplete>

<!--                        <v-autocomplete-->
<!--                            :items="cian.placementTypes"-->
<!--                            v-model="feed.cian.placement_type"-->
<!--                            label="Тип помещения"-->
<!--                            v-if="isShopping()"-->
<!--                            clearable-->
<!--                        ></v-autocomplete>-->

                        <v-autocomplete
                            :items="cian.conditionTypeForOffice"
                            v-model="feed.cian.condition_type"
                            v-if="isOffice()"
                            label="Состояние"
                            clearable
                        ></v-autocomplete>

                        <v-autocomplete
                            :items="cian.conditionTypeForFreeAppointmentAndShopping"
                            v-model="feed.cian.condition_type"
                            v-if="isShopping() || isFreeObject()"
                            label="Состояние"
                            clearable
                        ></v-autocomplete>

                        <v-checkbox
                            v-model="feed.cian.is_occupied"
                            label="Помещение занято"
                        ></v-checkbox>

<!--                        <v-autocomplete-->
<!--                            :items="cian.specialties"-->
<!--                            v-model="feed.cian.specialties"-->
<!--                            label="Возможное назначение"-->
<!--                            multiple-->
<!--                            clearable-->
<!--                            v-if="isShopping()"-->
<!--                        ></v-autocomplete>-->

                        <v-autocomplete
                            :items="cian.layouts"
                            v-model="feed.cian.layout"
                            label="Планировка"
                            clearable
                        ></v-autocomplete>

                        <v-autocomplete
                            :items="cian.yesNoChoices"
                            v-model="feed.cian.has_shop_windows"
                            label="Витринные окна"
                            clearable
                        ></v-autocomplete>

                        <v-autocomplete
                            :items="[{value: 'no', text: 'Нет'},{ value: 'yes', text: 'Есть'}]"
                            v-model="feed.cian.furniture_presence"
                            label="Мебель"
                            v-if="isOffice()"
                            clearable
                        ></v-autocomplete>

<!--                        <v-autocomplete-->
<!--                            :items="cian.inputTypes"-->
<!--                            v-model="feed.cian.input_type"-->
<!--                            label="Вход"-->
<!--                            v-if="isFreeObject() || isShopping()"-->
<!--                            clearable-->
<!--                        ></v-autocomplete>-->

<!--                        <v-checkbox-->
<!--                            v-model="feed.cian.has_furniture"-->
<!--                            label="Есть мебель в комнатах"-->
<!--                            v-if="isShopping()"-->
<!--                        ></v-checkbox>-->

<!--                        <v-checkbox-->
<!--                            v-model="feed.cian.has_internet"-->
<!--                            label="Есть интернет"-->
<!--                            v-if="isShopping()"-->
<!--                        ></v-checkbox>-->

                        <v-text-field
                            v-model="feed.cian.available_from"
                            label="Дата освобождения"
                        ></v-text-field>

<!--                        <v-checkbox-->
<!--                            v-model="feed.cian.has_shop_windows"-->
<!--                            label="Витринные окна"-->
<!--                            v-if="isShopping() || isFreeObject()"-->
<!--                        ></v-checkbox>-->

                        <v-checkbox
                            v-model="feed.cian.is_legal_address_provided"
                            label="Юридический адрес"
                        ></v-checkbox>

                        <v-text-field
                            v-model.number="feed.cian.water_pipes_count"
                            type="number"
                            label="Количество мокрых точек (водопровод)"
                        ></v-text-field>

                        <v-text-field
                            v-model.number="feed.cian.tax_number"
                            type="number"
                            label="Номер налоговой"
                        ></v-text-field>

                        <v-checkbox
                            v-model="feed.cian.is_in_hidden_base"
                            label="Размещение в закрытой базе"
                        ></v-checkbox>

<!--                        <v-autocomplete-->
<!--                            :items="cian.materialTypeChoices"-->
<!--                            v-model="feed.cian.material_type"-->
<!--                            clearable-->
<!--                            label="Тип дома"-->
<!--                            v-if="isOffice()"-->
<!--                        ></v-autocomplete>-->

<!--                        <v-autocomplete-->
<!--                            :items="isShopping() ? cian.heatingTypes : cian.heatingTypes.slice(0,3)"-->
<!--                            v-model="feed.cian.heating_type"-->
<!--                            clearable-->
<!--                            label="Отопление"-->
<!--                        ></v-autocomplete>-->

                    </v-form>

                </v-tab-item>

            </v-tabs-items>

        </template>
    </dialog-fullscreen>

</template>

<script>
    import DialogFullscreen from '@/components/elements/dialogs/Fullscreen.vue';
    import cianVariables from "../../../store/cianVariables";
    import feedVariables from "../../../store/feedVariables";

    export default {
        name: 'CianCommercialBuildingUpdateDialog',
        props: ['initialState', 'feed'],
        components: {'dialog-fullscreen': DialogFullscreen},
        data() {
            return {
                valid: false,
                indicator: false,
                activeTab: 0,
                isLoading: false,
                visibility: this.initialState,
                mKeys: false,
                feedVariables: feedVariables,
                keyItems: [],
                currentCursorPosition: 0,
                rules: {
                    required: value => !!value || 'Обязательное поле.',
                    email: v => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Неправильный электронный адрес',
                    maxLength: v => v && v.length <= 40 || 'Макс 40 символов',
                    descriptionMaxLength: v => v && v.length <= 5000 || 'Макс 5000 символов',
                },
                cian: {
                    metros: [],
                    buildings: [],
                    ...cianVariables.cian
                }
            }
        },
        methods: {
            isOffice() {
                return this.feed.cian.category === 'officeSale'
            },
            isFreeObject() {
                return this.feed.cian.category === 'freeAppointmentObjectSale'
            },
            isShopping() {
                return this.feed.cian.category === 'shoppingAreaSale';
            },
            isPremium() {
                return this.feed.cian.publish_terms === 'premium';
            },
            isTop() {
                return this.feed.cian.publish_terms === 'top3';
            },
            changeCategory() {
                if (this.feed.cian.category != 'shoppingAreaSale') {
                    delete this.feed.cian.placement_type
                }
            },
            saveCian() {
                let requestHeaders = {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': 'Bearer ' + String(this.$store.getters.userToken)
                }
                let requestData = {
                    'login': this.$store.getters.userLogin,
                }
                if (!this.isTop() && !this.isPremium()) {
                    this.feed.cian.title = null;
                }
                this.$http.put(this.$store.getters.endpoint + `/feeds/${this.feed.id}/cian`, {
                    ...requestData,
                    cian: this.feed.cian,
                    cian_feed_format: this.feed.cian_feed_format
                }, {
                    headers: {...this.$store.state.restrictedHeaders, ...requestHeaders}
                }).then((r) => {
                    let response = r.body;
                    if (response.result) {
                        console.log(response)
                        this.visibility = false;
                    } else {
                        console.log(response)
                    }
                })
            },
            addPhone() {
                this.feed.cian.phones.push(
                    {
                        country_code: '',
                        number: ''
                    }
                )
            },
            removePhone(index) {
                this.feed.cian.phones.splice(index, 1)
            },
             changeDinamicKey(key) {
                 let text_description = this.feed.cian.description
                 this.currentCursorPosition = event.path[0].selectionStart
                 if (key.keyCode == 192) {
                     if (!this.mKeys) {
                         this.mKeys = true
                     } else {
                         this.mKeys = false
                     }
                 }
                 this.keyItems = feedVariables.replaceKeys;
             },
             insertKeyInText(e) {
                 let F = this.feed.cian.description.substr(0, this.currentCursorPosition)
                 let L = this.feed.cian.description.substr(this.currentCursorPosition + 1)
                 this.feed.cian.description = F + e.target.textContent.trim() + L
                 this.mKeys = false
             }
        },
        watch: {
            initialState(value) {
                if (value) {
                    this.visibility = value;
                }

            },
            visibility(value) {
                this.$emit('update:initialState', value);
            },
        },
    }
</script>
